<template>
  <v-row no-gutters class="my-4">
    <v-col cols="12" lg="9">
      <v-chip v-for="(term, idx) in hrFilters" :key="idx" close small @click:close="onClose(idx)" class="mr-1">
        {{ term }}
      </v-chip>
    </v-col>
    <v-col cols="12" lg="3" class="text-right">
      <SearchSaver :context="context" v-if="filterObject" />
      <v-btn @click="doClear" depressed class="ml-4" v-if="filterObject">
        {{ $t('labels.clear') }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { EQ_OPERATOR, AND_SEPARATOR, LIKE_OPERATOR } from '../axios'
import { NAMESPACE } from '@argon/app/store'
import SearchSaver from './SearchSaver'

export default {
  name: 'AdvancedSearchSummary',
  components: { SearchSaver },
  props: {
    context: { type: String, required: true }
  },
  computed: {
    ...mapState(NAMESPACE, ['appliedFilters']),
    filterObject() {
      return this.appliedFilters[this.context]
    },
    filterItems() {
      return this.filterObject ? this.filterObject.items : []
    },
    hrFilters() {
      return this.filterItems.map((item) => {
        const field = this.$t(`labels.${item.field}`)
        const operator = this.$t(`labels.${item.operator}`)
        return `${field} ${operator} ${item.value}`
      })
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['setAppliedFilter', 'clearAppliedFilter']),
    onClose(idx) {
      const items = this.filterItems.filter((_, index) => index !== idx)
      this.setAppliedFilter({ context: this.context, filterObject: { separator: AND_SEPARATOR, items } })
    },
    doClear() {
      this.clearAppliedFilter(this.context)
    }
  }
}
</script>
